import Swiper from "swiper";
import { clickOn, load, initTimer, onResize } from "../events/events.js";
// Переваги

const advantages = {
  section: "#advantages",
  buttons: ["#advantages .prev", "#advantages .next"],
  index: window.innerWidth < 992 ? 0 : 3,
  canSwipe: false,
  swipers: {
    text: undefined,
    images: undefined,
  },
  counter: document.querySelector("#advantages .counter"),
  init: function () {
    this.swipers.text = text_advantages;
    this.swipers.images = images_advantages;
    setTimeout(() => {
      console.log("setHeight");
      this.setHeight();
      this.canSwipe = true;
    }, 1000);
  },
  next: function () {
    if (!this.canSwipe) return;
    if (this.index === this.swipers.text.slides.length - 1) {
      document.querySelector(this.buttons[1]).classList.remove("canNext");
      return;
    }
    this.canSwipe = false;
    setTimeout(() => {
      this.canSwipe = true;
    }, 1000);
    this.index++;

    document.querySelector(this.buttons[0]).classList.add("canPrev");

    Object.values(this.swipers).forEach((swiper) => {
      swiper?.slideNext?.();
    });

    if (this.swipers.text.realIndex === this.swipers.text.slides.length - 1) {
      document.querySelector(this.buttons[1]).classList.remove("canNext");
    } else {
      document.querySelector(this.buttons[1]).classList.add("canNext");
    }
  },
  prev: function () {
    if (!this.canSwipe) return;
    if (this.index === 0) {
      document.querySelector(this.buttons[0]).classList.remove("canPrev");
      return;
    }
    this.canSwipe = false;
    setTimeout(() => {
      this.canSwipe = true;
    }, 1000);
    this.index--;

    document.querySelector(this.buttons[1]).classList.add("canNext");

    Object.values(this.swipers).forEach((swiper) => {
      swiper?.slidePrev?.();
    });

    if (this.index === 0) {
      document.querySelector(this.buttons[0]).classList.remove("canPrev");
    } else {
      document.querySelector(this.buttons[0]).classList.add("canPrev");
    }
  },
  setHeight: function () {
		if(!this.swipers.images) return;
    let maxHeight,
      calc = () => {
        return (
          Math.max(
            ...advantages.swipers.images.slides.map((slide) => {
              if (!slide.querySelector(".image-thumb")) return 0;
              return getComputedStyle(
                slide.querySelector(".image-thumb")
              ).height.split("px")[0];
            })
          ) + "px"
        );
      };
    maxHeight = calc();

    advantages.swipers.images?.hostEl?.style.setProperty("height", maxHeight);
  },
  updateCounter: function () {
    if (!this.counter || !this.swipers.images) return;
    const index = window.innerWidth < 992 ? -2 : 1;
    this.counter.textContent = `${this.swipers.images.realIndex + index}/${
      this.swipers.images.slides.filter((e) => !e.classList.contains("hidden"))
        .length
    }`;
  },
};

clickOn(advantages.buttons[0], advantages.prev.bind(advantages));
clickOn(advantages.buttons[1], advantages.next.bind(advantages));
load(advantages.init.bind(advantages));

const text_advantages = new Swiper(`${advantages.section} .text-swiper`, {
  slidesPerView: 1,
	autoHeight: true,
  breakpoints: {
    992: {},
  },
  on: {
    init: function () {
      this.slideTo(advantages.index);
      if (!this.isEnd) {
        document.querySelector(advantages.buttons[1]).classList.add("canNext");
      }
      if (!this.isBeginning) {
        document.querySelector(advantages.buttons[0]).classList.add("canPrev");
      }
    },
    breakpoint: function () {
      this.slideTo(advantages.index);
      advantages.updateCounter.bind(advantages)();
    }
  },
});

const images_advantages = new Swiper(
  `${advantages.section} .advantages-images`,

  {
    slidesPerView: 1,
    spaceBetween: 20,
    allowTouchMove: false,
    grabCursor: false,
    breakpoints: {
      992: {
        slidesPerView: "auto",
      },
    },
    on: {
      init: function () {
        this.slideTo(advantages.index);
        initTimer(
          "initTimer",
          () => {
            advantages.updateCounter.bind(advantages)();
          },
          500
        );
      },
      slideChange: function () {
				this.hostEl.addEventListener("transitionend", (e) => {
					if(e.propertyName === "transform"){
						images_advantages?.update();
					}
				})
        const index = window.innerWidth < 992 ? 3 : 0;
        advantages.updateCounter.bind(advantages)();
        let link =
          document
            .querySelector(`${advantages.section} .vire-more`)
            .getAttribute("href")
            .split("#")[0] +
          "#" +
          (this.realIndex - index);
        document
          .querySelector(`${advantages.section} .vire-more`)
          .setAttribute("href", link);
      },
      breakpoint: function () {
        initTimer(
          "images",
          () => {
            const index =
              window.innerWidth < 992 ? advantages.index + 3 : advantages.index;
            this.slideTo(index);
          },
          100
        );
      },
    },
  }
);

onResize(() => {
  initTimer("updateHeight", () => {
		advantages.setHeight.bind(advantages)();
	}, 400);
}, 1441);
